"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _immutable = _interopRequireDefault(require("immutable"));

var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _unescapedText = _interopRequireDefault(require("I18n/utils/unescapedText"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H7"));

var _UITag = _interopRequireDefault(require("UIComponents/tag/UITag"));

var _UIRouterLink = _interopRequireDefault(require("ui-addon-react-router-dom/UIRouterLink"));

var _hubspotFeatures = require("ecosystem-marketplace-core/constants/groupTags/hubspotFeatures");

var HubSpotFeature = _interopRequireWildcard(require("ecosystem-marketplace-core/constants/groupTags/HubSpotFeature"));

var _i18n = require("ecosystem-marketplace-core/utils/i18n");

var _FilterTag = _interopRequireDefault(require("./FilterTag"));

var _FilterKey = require("../../../constants/search/FilterKey");

var featuresMap = _immutable.default.OrderedMap({
  CRM: _hubspotFeatures.BY_PRODUCT.CRM,
  MARKETING: _hubspotFeatures.BY_PRODUCT.MARKETING,
  SALES: _hubspotFeatures.BY_PRODUCT.SALES,
  SERVICE: _hubspotFeatures.BY_PRODUCT.SERVICE,
  CMS: _hubspotFeatures.BY_PRODUCT.CMS
});

var HubSpotFeaturesGroup = function HubSpotFeaturesGroup(_ref) {
  var groupKey = _ref.groupKey,
      hubspotFeatures = _ref.hubspotFeatures,
      getFilterLink = _ref.getFilterLink,
      isPreview = _ref.isPreview;
  return _react.default.createElement(_react.Fragment, null, _react.default.createElement(_H.default, {
    "aria-level": 6,
    className: "m-top-2 m-bottom-2"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "ecosystemMarketplaceCore.groupTags.hubspotFeatureGroups." + groupKey
  })), hubspotFeatures.map(function (hubspotFeature) {
    return [hubspotFeature, (0, _i18n.getHubSpotFeatureI18nKey)(hubspotFeature)];
  }).sortBy(function (_ref2) {
    var _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
        __ = _ref3[0],
        hubspotFeatureI18nKey = _ref3[1];

    return (0, _unescapedText.default)(hubspotFeatureI18nKey);
  }).map(function (_ref4) {
    var _ref5 = (0, _slicedToArray2.default)(_ref4, 2),
        hubspotFeature = _ref5[0],
        hubspotFeatureI18nKey = _ref5[1];

    return _react.default.createElement(_UIRouterLink.default, {
      key: hubspotFeature,
      disabled: isPreview,
      to: getFilterLink(_FilterKey.HUBSPOT_FEATURES, hubspotFeature, true)
    }, _react.default.createElement(_FilterTag.default, null, _react.default.createElement(_UITag.default, {
      className: "m-left-0 m-right-3"
    }, _react.default.createElement(_FormattedMessage.default, {
      message: hubspotFeatureI18nKey
    }))));
  }).toArray());
};

var HubSpotFeatures = function HubSpotFeatures(_ref6) {
  var hubspotFeatures = _ref6.hubspotFeatures,
      getFilterLink = _ref6.getFilterLink,
      isPreview = _ref6.isPreview;
  var filteredFeatures = (0, _react.useMemo)(function () {
    return featuresMap.map(function (allFeaturesForProduct) {
      return hubspotFeatures.filter(function (flatFeature) {
        return allFeaturesForProduct[flatFeature];
      });
    }).filter(function (features) {
      return !features.isEmpty();
    });
  }, [hubspotFeatures]);
  return _react.default.createElement(_react.Fragment, null, filteredFeatures.map(function (features, groupKey) {
    return _react.default.createElement(HubSpotFeaturesGroup, {
      key: groupKey,
      groupKey: groupKey,
      hubspotFeatures: features,
      getFilterLink: getFilterLink,
      isPreview: isPreview
    });
  }).toArray());
};

HubSpotFeatures.propTypes = {
  hubspotFeatures: _reactImmutableProptypes.default.setOf(_propTypes.default.oneOf(Object.values(HubSpotFeature))).isRequired,
  getFilterLink: _propTypes.default.func.isRequired,
  isPreview: _propTypes.default.bool.isRequired
};
var _default = HubSpotFeatures;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/detail/overview/HubSpotFeatures.js
// module id = 819
// module chunks = 209 210 211 212